import React from "react";
import { Button, Label } from "reactstrap";
import style from "./Button.scss";

const CounterBox = ({
  boxWidth,
  height,
  label,
  labelColor,
  handleClick,
  icon,
  marginLeft,
  iconSvg,
  roundedXs,
  backgroundColor,
  primary,
}) => {
  return (
    <div
      style={{ width: boxWidth, height: height, backgroundColor: backgroundColor }}
      className={`${roundedXs && style.roundedXs} ${style.divCounterBox} ${primary && style.activeButton}`}
    >
      <Label style={{ marginLeft: marginLeft, color: labelColor }} className={style.labelCounterBox}>
        {label.text}
      </Label>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {label.number && (
          <div className={style.numberCounterBox}>
            <Label className={style.labelNumber}>{label.number}</Label>
          </div>
        )}
        <img
          style={{ height: "20px", width: icon.width, alignSelf: "center" }}
          src={icon.src}
          onClick={handleClick}
        ></img>
      </div>
    </div>
  );
};
export default CounterBox;
